<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalCertificate">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-pencil"></i> Assinar documento {{file.arquivo_nome}}</p>
                    <button type="button" class="close" @click="closeModal()" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="requireDocument">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label :class="{ 'text-danger': errors.has('Documento') }"><i
                                        class="fa fa-list-alt"></i> CPF</label>
                                <input v-mask="'###.###.###-##'" v-validate="{required: true, document: true}"
                                    :class="{ 'is-invalid': errors.has('Documento') }" class="form-control"
                                    name="Documento" v-model="request.assinatura_documento" placeholder="Documento">
                                <div class="invalid-feedback help-block error">{{errors.first('Documento')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <token-otp ref="inputOtp" @changed="setToken" :tokenTipo="tokenTipo">
                                </token-otp>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="error" class="col-md-12">
                            <div class="alert bg-red alert-dismissible">
                                <h5><b><i class="icon fa fa-exclamation-triangle"></i></b>
                                    {{errorMessage}}</h5>
                                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                            </div>
                        </div>
                        <div v-if="!error">
                            <certificate-choice :request="request" ref="certificateChoice"></certificate-choice>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="callout callout-success">
                                <h6><b><i class="fa fa-shield"></i></b>
                                    O documento será assinado com o certificado digital selecionado.</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" @click="closeModal()" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" id="signButton" :disabled="loading || error  || !request.token_otp"
                        @click="sign()" class="btn btn-success float-right"><i class="fa fa-check"></i>
                        Assinar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TokenOtp from '../token-otp.vue';
    import CertificateChoice from './certificate-choice.vue';
    export default {
        components: {
            TokenOtp,
            CertificateChoice
        },
        props: {
            requireDocument: Boolean,
            tokenTipo: String
        },
        data() {
            return {
                loading: false,
                token: null,
                error: false,
                errorMessage: null,
                file: {
                    id: null,
                    arquivo_nome: null
                },
                request: {
                    assinatura_documento: '',
                    file: null,
                    token: null,
                    certificate: null,
                    token_otp: null,
                },
            }
        },
        methods: {
            closeModal() {
                Object.assign(this.$data, this.$options.data());
                this.$validator.reset();
                $('#ModalCertificate').modal('toggle');
            },
            setToken(payload) {
                this.request.token_otp = payload;
            },
            sign() {
                if (!this.request.certificate) {
                    toastr({
                        title: 'Selecione um certificado!',
                        icon: 'error'
                    });
                    return;
                }
                if (!this.request.token_otp) {
                    toastr({
                        title: 'Informe o token!',
                        icon: 'error'
                    });
                    return
                }
                if (this.$refs.certificateChoice.getDocument() != this.request.assinatura_documento && process
                    .env
                    .NODE_ENV == 'production') {
                    toastr({
                        title: 'O documento (CPF) do certificado não é o mesmo informado na assinatura.',
                        icon: 'warning'
                    });
                    return;
                }
                this.loading = true;
                this.prepareSign();
            },
            prepareSign() {
                this.$store.dispatch('prepareSignFilePublic', this.$route.params.id).then(response => {
                    this.$refs.certificateChoice.token = response.token;
                    this.error = false;
                    this.$refs.certificateChoice.sign().then(response => {
                        this.submitFile();
                    }).catch(errorSign => {
                        toastr({
                            title: errorSign,
                            icon: 'error'
                        });
                        console.log(errorSign);
                        this.loading = false;
                    });
                }).catch(error => {
                    this.error = true;
                    this.errorMessage = error.message;
                });
            },
            submitFile() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        return;
                    }
                    this.request.signature = this.$route.params.id;
                    this.request.documento = this.$refs.certificateChoice.selectedCert.documento;
                    this.request.token = this.$refs.certificateChoice.token;
                    this.loading = true;
                    this.$store.dispatch('signFilePublic', this.request).then(response => {
                        toastr({
                            icon: response.status,
                            title: response.message
                        });
                        $('#ModalCertificate').modal('toggle');
                        setTimeout(() => {
                            this.$router.push(`/validador?arquivo=${this.file.id}`);
                        }, 500);
                    }).catch(error => {
                        toastr({
                            icon: error.status,
                            title: error.message
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            }
        }
    }
</script>